export function roundOff(num, places) {
  const x = Math.pow(10, places)
  return Math.round(num * x) / x
}

export function roundOffFloor(num, places) {
  const x = Math.pow(10, places)
  return Math.floor(num * x) / x
}
